module.exports = __webpack_public_path__ + "img/category-2.d64a39c0.png";